import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GoogleTagManagerService, ShoppingcartService } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { Material } from '../shared/material.model';
import { Package } from '../shared/package.model';
import { GetPackageProductsRequest } from '../shared/get-package-products.request';
import { GetPackageProductsResponse } from '../shared/get-package-products.response';
import { GetPackageProductsUseCase } from '../use-cases/get-package-products.usecase';

@Component({
    selector: 'pf-package-products',
    templateUrl: './package-products.component.html',
    styleUrls: ['./package-products.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class PackageProductsComponent implements OnInit {
    id = 0;
    originalPrice = 0;
    packageObject: Package = {};
    packagePrice = 0;
    packageProductRequest: GetPackageProductsRequest = {};
    products: Material[] = [];
    routerLink = '';

    constructor(
        private _shoppingCartService: ShoppingcartService,
        private _googleTagManagerService: GoogleTagManagerService,
        private _GetPackageProductsUseCase: GetPackageProductsUseCase
    ) {}

    ngOnInit(): void {
        //TODO backend works with id request, has to be solved. Backend needs id to get products. Put id to session or make a service to store it
        const last = window.location.href.split('/').pop();
        const lastSegmentOfUrlList = last?.split('?');

        if (lastSegmentOfUrlList) {
            const lastSegmentOfUrl = lastSegmentOfUrlList[0];
            this.routerLink = lastSegmentOfUrl;
        }
        this.packageProductRequest = {
            routerLink: this.routerLink
        };
        (this._GetPackageProductsUseCase.execute(this.packageProductRequest) as Observable<GetPackageProductsResponse>).subscribe(
            (packageProductResponse) => {
                const response = packageProductResponse;
                this.packageObject = response.packageObject as Package;
                this.products = response.products as Material[];
                this.products.forEach((product) => {
                    this.packagePrice += product.packagePrice!;
                    this.originalPrice += product.originalPrice!;
                });

                //adding select_item into dataLayer to google
                this._googleTagManagerService.selectPackageItem(this.packageObject, this.products);

                this.initializeProducts();
            }
        );
    }

    initializeProducts() {
        // this.filteredPublication = this.publication;

        this.products.forEach((value) => {
            if (value.webshopPriceActive) {
                value.oldPrice = value.originalPrice;
                value.originalPrice = value.webshopPrice;
            }
        });
        if (this.routerLink.includes(this.packageObject.routerLink as string)) {
            this.id = this.packageObject.id!;
        }
    }

    addToCartPackage() {
        this.initializePackage();
        this._shoppingCartService.addToCartPackage(this.products, this.packageObject);
    }

    initializePackage() {
        this.products.forEach((value) => {
            value.oldPrice = value.originalPrice;
            value.originalPrice = value.packagePrice;
            value.packageName = this.packageObject.packageName;
        });
        this.products[0].firstElementOfPackage = true;
    }
}
